import { UserRoleCodes } from '@/types'

import { checkRights } from '@/helpers'

export default [
  {
    path: 'giftcards/card/:id?/general',
    name: 'manager-giftcards-item-general',
    component: () =>
      import('../../../views/Manager/GiftCards/ManagerGiftCardItemGeneral.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'giftcards/card/:id?/seo',
    name: 'manager-giftcards-item-seo',
    component: () =>
      import('../../../views/Manager/GiftCards/ManagerGiftCardItemSeo.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
]
